import {
  BranchesApiFactory,
  BrandsApiFactory,
  Configuration,
  DefaultApiFactory,
  MarketAnalysisApiFactory,
  MeApiFactory,
  MenuItemsApiFactory,
  MetaApiFactory,
  ServiceApiFactory,
  WatchlistApiFactory,
} from '@growdash/growintel/generated';

import { InitializeService } from '../types/initialize-service';

export type GrowIntelService = {
  [K in keyof typeof apiFactories]: ReturnType<(typeof apiFactories)[K]>;
};

export const apiFactories = {
  metaAPI: MetaApiFactory,
  brandsAPI: BrandsApiFactory,
  defaultAPI: DefaultApiFactory,
  serviceAPI: ServiceApiFactory,
  branchesAPI: BranchesApiFactory,
  menuItemsAPI: MenuItemsApiFactory,
  watchlistAPI: WatchlistApiFactory,
  marketAnalysisAPI: MarketAnalysisApiFactory,
  meAPI: MeApiFactory,
};

export const createGrowintelService = (params: InitializeService) => {
  const baseConfig = { basePath: params.service_url };

  const apiQueryConfig = new Configuration(baseConfig);
  const { accessToken } = params;
  const config = accessToken
    ? new Configuration({ ...baseConfig, accessToken })
    : apiQueryConfig;
  return Object.fromEntries(
    Object.entries(apiFactories).map(([key, factory]) => [
      key,
      factory(config),
    ]),
  ) as GrowIntelService;
};
